import Vuex, { GetterTree, ActionTree, MutationTree, Action } from 'vuex';

interface IContactList {
  [key: string]: any;
  loading: boolean;
  infos: Array<{ [key: string]: any }>;
}
interface IContactUpdate {
  loading: boolean;
  result: object;
}

export interface IState {
  [key: string]: any;
}

export const state: IState = {
  contactList: {
    loading: false,
    infos: []
  } as IContactList,
  contactUpdate: {
    loading: false,
    result: {}
  } as IContactUpdate
};

// tslint:disable-next-line:ban-types
export const getters: GetterTree<IState, Function> = {
  contactList: (myState: IState) => myState.contactList,
  contactUpdate: (myState: IState) => myState.contactUpdate
};
